<template>
  <div class="tracking-label" :class="[{hover: isHovered, static: isStatic, bounce: isBounce }]">
    <div
      class="tracking-label-inner"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
      @click.stop="$emit('click')"
    >
      <i class="icon inner-icon default" :class="icon || defaultIconClass"></i>
      <i class="icon inner-icon hover" :class="icon || hoverIconClass"></i>
      <p v-if="hoverText" class="text">{{ hoverText }}</p>
    </div>
    <i v-if="isBounce" class="icon--arrow-down"></i>
  </div>
</template>

<script>
export default {
  name: 'TrackingLabel',
  props: {
    hoverText: {
      type: String,
      required: false
    },
    isStatic: {
      type: Boolean,
      default: false
    },
    isHovered: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      required: false
    },
    ratio: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      required: false
    },
    isBounce: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isProcessing: false
    }
  },
  computed: {
    defaultIconClass () {
      switch (true) {
        case this.ratio >= 0.666:
          return 'icon--faucet-lv3'
        case this.ratio >= 0.333:
          return 'icon--faucet-lv2'
        default:
          return 'icon--faucet-lv1'
      }
    },
    hoverIconClass () {
      switch (true) {
        case this.ratio >= 0.666:
          return 'icon--faucet-negative-lv3'
        case this.ratio >= 0.333:
          return 'icon--faucet-negative-lv2'
        default:
          return 'icon--faucet-negative-lv1'
      }
    }
  },
  methods: {
    onMouseEnter (e) {
      this.$emit('onMouseEnter', e)
    },
    onMouseLeave (e) {
      this.$emit('onMouseLeave', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.tracking-label {
  position: relative;
  .tracking-label-inner {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 3px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 0 0 1px #0000000A, 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
    transition: all 200ms cubic-bezier(0, 0, 0.58, 1);
    cursor: pointer;

    .inner-icon {
      &.default {
        display: block;
      }
      &.hover {
        display: none;
      }
    }

    .text {
      display: none;
      color: #fff;
      font-size: 13px;
      line-height: 1;
      font-weight: 600;
    }
  }

  &.bounce {
    .tracking-label-inner {
      animation: scaleUp 1200ms cubic-bezier(0.48, 0.01, 0.48, 0.96) infinite;
      @keyframes scaleUp {
        0% {
          scale: 1;
        }
        30% {
          scale: 1;
        }
        65% {
          scale: 1.05;
        }
        100% {
          scale: 1.05;
        }
      }
    }
    .icon--arrow-down {
      position: absolute;
      top: -21px;
      left: 6px;
      animation: bounceDown 1200ms cubic-bezier(0.48, 0.01, 0.48, 0.96) infinite;
      animation-delay: 1ms;

      @keyframes bounceDown {
        0% {
          opacity: 0;
          transform: translateY(0);
        }
        30% {
          opacity: 1;
          transform: translateY(2px);
        }
        65% {
          transform: translateY(5px);
        }
        90% {
          opacity: 1;
          transform: translateY(5px);
        }
        100% {
          opacity: 0;
          transform: translateY(5px);
        }
      }
    }
  }

  &:hover, &.hover {
    .tracking-label-inner {
      background: #ec0047;
      animation: none;
      .text {
        display: block;
      }
      .inner-icon {
        &.default {
          display: none;
        }
        &.hover {
          display: block;
        }
      }
    }
    .icon--arrow-down {
      display: none;
    }
    &:not(.static) {
      .tracking-label-inner {
        padding-right: 8px;
      }
    }
  }
}
</style>
